// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { SlTpPriceType } from '../../Utils/Enums/Constants.js'
import { DirectMessageCode } from './DirectMessageCodes.ts'
import { ProductType } from '../Instruments/ProductType.js'

export let DirectOpenOrderMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_OPEN_ORDER)
    // значение sl в цене или тиках в зависимости от SlPriceType
    this.StopLossPriceValue = NaN
    // значение tp в цене или тиках в зависимости от TPPriceType
    this.TakeProfitPriceValue = NaN
    this.StopLossPriceType = SlTpPriceType.Absolute
    this.TakeProfitPriceType = SlTpPriceType.Absolute

    // TODO. Refactor? Remove?
    this.stopLossLimit = 0                // #91413
    this.takeProfitLimit = 0

    this.OrderWasManual = null
    this.Account = null
    this.BuySell = 0
    this.OrderNumber = null
    this.OrderType = 0
    this.Price = 0
    this.LastPrice = null
    this.Quantity = 0
    this.LastAmount = null
    this.RemoteID = null
    this.Replaceable = false
    this.AutoTradeOrder = false
    this.Route = null
    this.SharesFilled = 0
    this.EverageFilledPrice = 0
    this.StopLimit = 0
    this.Symbol = null
    // Под нефикс список, для прочих - бери Symbol и не парься
    this.InstrumentID = 0
    this.UTCDateTime = null
    this.TimeInForce = 0
    this.Token = '-1'
    this.ExecutionType = null
    this.OrderStatus = null
    this.PositionId = '-1'
    this.disClosedQuantity = null

    this.comment = null
    this.lackOfMargin = null    //#94155

    // для GTD
    this.ExpireTime = null
    this.ProductType = ProductType.General

    this.boundToOrderId = '-1'

    this.OCOGroupID = null

    this.IsActivated = false      // #92963
    this.active = false
    // признак что ордер открывающий        
    this.IsOpen = false
    // #34674
    this.realactive = false

    this.OrderGroupId = 0

    this.FMasterID = null

    this.FOrderCreatedByUser = null

    this.FLastUpdateTime = null
    this.trStopOffset = 0

    this.Exchange = null
    this.InitMargin = 0
    this.Roundtrip = 0

    this.externalOrderId = null
    this.externalStatus = 0

    this.TriggerSL = null   //#109798
    this.TriggerTP = null
    this.TriggerSLTP = null

    this.TradingSignalId = 0
    // Управление разрешением SLTP на уровне отдельного ордера
    // заводили под интеграции, нашим сервером пока не используется
    this.SLTPAllowed = true
    // Панель с которой был отправлен Ордер
    this.FClientPanelId = 0
    // Все параметры ордера
    this.AdvancedOrderTypeParameters = null

    this.InstrumentTradableID = null;
}

DirectOpenOrderMessage.prototype = Object.create(DirectMessageBase.prototype)

// TODO. Refactor? Remove?
Object.defineProperty(DirectOpenOrderMessage.prototype, 'StopLossLimit', {
    get: function () { return this.stopLossLimit },
    set: function (val) { this.stopLossLimit = val }
})

// TODO. Refactor? Remove?
Object.defineProperty(DirectOpenOrderMessage.prototype, 'TakeProfitLimit', {
    get: function () { return this.takeProfitLimit },
    set: function (val) { this.takeProfitLimit = val }
})

Object.defineProperty(DirectOpenOrderMessage.prototype, 'Comment', {
    get: function () { return this.comment },
    set: function (val) { this.comment = val }
})
Object.defineProperty(DirectOpenOrderMessage.prototype, 'LackOfMargin', {    //#94155
    get: function () { return this.lackOfMargin },
    set: function (val) { this.lackOfMargin = val }
})

Object.defineProperty(DirectOpenOrderMessage.prototype, 'BoundToOrderId', {
    get: function () { return this.boundToOrderId },
    set: function (val) { this.boundToOrderId = val }
})

Object.defineProperty(DirectOpenOrderMessage.prototype, 'Active', {
    get: function () { return this.active },
    set: function (val) { this.active = val }
})

// #34674
Object.defineProperty(DirectOpenOrderMessage.prototype, 'RealActive', {
    get: function () { return this.realactive },
    set: function (val) { this.realactive = val }
})

Object.defineProperty(DirectOpenOrderMessage.prototype, 'MasterID', {
    get: function () { return this.FMasterID },
    set: function (val) { this.FMasterID = val }
})

Object.defineProperty(DirectOpenOrderMessage.prototype, 'OrderCreatedByUser', {
    get: function () { return this.FOrderCreatedByUser },
    set: function (val) { this.FOrderCreatedByUser = val }
})

Object.defineProperty(DirectOpenOrderMessage.prototype, 'LastUpdateTime', {
    get: function () { return this.FLastUpdateTime },
    set: function (val) { this.FLastUpdateTime = val }
})

// Офсет (только для трейлинг стопа)
Object.defineProperty(DirectOpenOrderMessage.prototype, 'TrStopOffset', {
    get: function () { return this.trStopOffset },
    set: function (val) { this.trStopOffset = val }
})

Object.defineProperty(DirectOpenOrderMessage.prototype, 'ExternalOrderId', {
    get: function () { return this.externalOrderId },
    set: function (val) { this.externalOrderId = val }
})

Object.defineProperty(DirectOpenOrderMessage.prototype, 'ExternalStatus', {
    get: function () { return this.externalStatus },
    set: function (val) { this.externalStatus = val }
})

// Панель с которой был отправлен Ордер
Object.defineProperty(DirectOpenOrderMessage.prototype, 'ClientPanelId', {
    get: function () { return this.FClientPanelId },
    set: function (val) { this.FClientPanelId = val }
})

Object.defineProperty(DirectOpenOrderMessage.prototype, 'DisClosedQuantity', {
    get: function () { return this.disClosedQuantity },
    set: function (val) { this.disClosedQuantity = val }
})